import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import '../app.css'
import App from '../App.vue'
import plansRoutes from '../router/routes/plans'
import { initSentry } from '../lib/sentry'

// Branding
document.title = 'Plans | Codifyo'
const faviconLink = document.getElementById('favicon-link')
if (faviconLink) {
    faviconLink.setAttribute('href', '/favicon-plans.png')
}

const router = createRouter({
    history: createWebHistory(),
    routes: plansRoutes,
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && !localStorage.getItem('apiToken')) {
        next({ name: 'plans_login' })
    } else {
        next()
    }
})

const app = createApp(App)
app.use(router)
initSentry(app, router)
app.mount('#app')
